// Author Lin
// Date 2024-07-30 14:37:40

import * as model from "@/model/sithMes/inventory/SithMesInventoryItemModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {customVuexFilterPatternFactory} from "@/store/em/commonPattern/customVuexFilterPatternFactory";
import {customVuexVoPatternFactory} from "@/store/em/commonPattern/customVuexVoPatternFactory";
import {customVuexEntityPatternFactory} from "@/store/em/commonPattern/customVuexEntityPatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesInventoryItem(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_INVENTORY_URL,
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'receive103Filter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'receive105Filter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'receive101Filter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexEntityPatternFactory, {
        entityState: 'receive103Entity',
        entityConstructor: model.SithMesInventoryItem
    })
    .withPatternFactory(customVuexEntityPatternFactory, {
        entityState: 'receive105Entity',
        entityConstructor: model.SithMesInventoryItem
    })
    .withPatternFactory(customVuexEntityPatternFactory, {
        entityState: 'receive101Entity',
        entityConstructor: model.SithMesInventoryItem
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'receive103Vo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'receive105Vo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'receive101Vo'
    })
    .buildStore()
